;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { ComponentProps } from 'react'

import { PaginationDeprecated } from './PaginationDeprecated'
import { PaginationRebranded } from './PaginationRebranded'

export function PaginationStrategy({
  rebranded = false,
  ...props
}: {
  rebranded?: boolean
} & ComponentProps<typeof PaginationDeprecated>) {
  if (rebranded) {
    return <PaginationRebranded rebranded {...props} />
  }

  return <PaginationDeprecated {...props} />
}
